<template>
  <div class="forum">
    <m-banner :bg="banner.imgUrl" />
    <search-input />
    <nav-list />

    <div class="intro block center-box">
      <m-pane-title title="论坛介绍" sub-title="Introduction" />

      <p class="txt-align" :class="lang === 'en' ? 'en-txt-align' : ''" v-for="(item, i) in (intro.description || '').split('|')" :key="i">{{item}}</p>
    </div>

    <div class="back block center-box">
      <m-pane-title title="成立背景" sub-title="Background" />
    </div>

    <div class="pur-con block center-box">
      <div class="item" v-for="item in background" :key="item.id">
        <img :src="item.pcImgUrl" alt="">
        <div class="txt-box">
          <span>{{item.title}}</span>
          <div></div>
          <p class="txt-align" :class="lang === 'en' ? 'en-txt-align' : ''">
            {{item.description}}</p>
        </div>
      </div>
    </div>

    <div class="mission center-box block">
      <m-pane-title title="愿景与使命" sub-title="Vision and mission" />

      <div class="con">
        <div class="box box-1">
          <img class="cov-img" src="../../assets/about/con-2.jpg" alt="">
          <div class="txt-box">
            <div>
              <p>GF60{{lang === 'zh' ? '愿景' : 'Vision'}}</p>
              <p class="txt-align" :class="lang === 'en' ? 'en-txt-align' : ''">{{lang === 'zh' ? vision : enVision}}</p>
            </div>
          </div>
        </div>
        <div class="box box-2">
          <div class="txt-box">
            <div>
              <p>GF60{{lang === 'zh' ? '使命' : 'Mission'}}</p>
              <p class="txt-align" :class="lang === 'en' ? 'en-txt-align' : ''">{{lang === 'zh' ? mission : enMission}}</p>
            </div>
          </div>
          <img class="cov-img" src="../../assets/about/con-1.jpg" alt="">
        </div>
      </div>
    </div>

<!--    <div class="work center-box block">-->
<!--      <m-pane-title title="工作重点" sub-title="Aims" />-->
<!--      <div class="item" v-for="item in workFocusList" :key="item.id">-->
<!--        <img :src="item.pcImgUrl" alt="">-->
<!--        <div class="txt-box">-->
<!--          <p>{{item.title}}</p>-->
<!--          <p :class="lang === 'en' ? 'en-txt-align' : ''">-->
<!--            {{item.description}}-->
<!--          </p>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

    <div class="research-area block">
      <div class="center-box">
        <m-pane-title title="研究方向" sub-title="Research Area" />
      </div>

<!--      <div></div>-->
      <div class="ra-item center-box" v-for="(item, i) in researchAreaList" :key="i">
        <div class="tit-img">
          <div class="img-box">
            <img :src="require('../../assets/about/' + item.imgUrl)" alt="">
          </div>
          <div class="txt-box">
            <span>{{ lang === 'en' ? item.enTit : item.tit }}</span>
            <span v-if="lang === 'zh'">{{ item.enTit }}</span>
          </div>
        </div>
        <div class="intro txt-align">
          {{ lang === 'en' ? item.enDesc : item.desc }}
        </div>
      </div>

      <div class="ra-menu-list center-box">
        <div class="ra-menu-item" v-for="(item, i) in researchMenuList" :key="i">
          <img :src="require('../../assets/about/' + item.imgUrl)" alt="">
          <p>{{lang === 'en' ? item.enTit : item.tit}}</p>
        </div>
      </div>
    </div>

    <div class="scope-work center-box block">
      <m-pane-title title="运营模块" sub-title="Scope of Work" />
      <div :class="{'work-item': true, [`work-item-${i}`]: true}" v-for="(item, i) in scopeWorkList">
        <div class="img">
          <img :src="require('../../assets/about/' + item.imgUrl)" alt="">
        </div>
        <div class="other-msg">
          <p>{{ lang === 'en' ? item.enTit : item.tit }}</p>
          <div class="line"></div>
          <div class="desc-box">{{lang === 'en' ? item.enDesc : item.desc}}</div>

<!--          <div v-if="i === 0" class="float-num">01</div>-->
        </div>
      </div>
    </div>

    <div class="major-event center-box block">
      <m-pane-title title="里程碑" sub-title="Milstone" />

      <img :src="lcbImgUrl" alt="">
<!--      <div class="event-wrap">-->
<!--        <div class="line-wrap">-->
<!--          <div class="left-dash-line"></div>-->
<!--        </div>-->

<!--        <div class="wrap-list">-->
<!--          <div class="wrap-list-item" v-for="(item, i) in testLCBList" :key="i">-->
<!--            <div class="img has-circle">-->
<!--              <img :src="require('../../assets/about/' + item.yearImg)" alt="">-->
<!--            </div>-->
<!--            <div class="event-item has-circle" v-for="(eitem, j) in item.eventList" :key="j">-->
<!--              <div class="time-box">{{eitem.time}}</div>-->
<!--              <div class="desc-box">{{lang === 'en' ? eitem.enDesc : eitem.desc}}</div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
    </div>

    <back-home />
  </div>
</template>

<script>
import {forumPageData, researchAreaList, researchMenuList, scopeWorkList, testLCBList} from "../../utils/Local-Data";
const {vision, mission, enMission, enVision} = forumPageData;
export default {
  name: "Forum",
  data() {
    return {
      banner: {},
      intro: {},
      background: [],
      workFocusList: [],
      vision, mission, researchAreaList, researchMenuList, scopeWorkList, testLCBList,
      enMission, enVision,
      lcbImgUrl: ''
    }
  },
  computed: {
    lang() {
      return this.$store.state.mlang;
    }
  },
  methods: {
    filterData(records) {
      this.lcbImgUrl = records['221'][0].jumpUrl;
      this.intro = records['201'][0];
      this.background = records['202'];
      this.workFocusList = records['204'];
    },
    getData(language) {
      this.$http.getOnlyContent({
        itemType: '2',
        platform: 'pc',
        language
      }).then(res => {
        this.filterData(res.crmOweContentMaps || {});
      });
    },
    getDataByLang(lang) {
      if(lang === 'zh') {
        this.getData('china');
      } else {
        this.getData('english');
      }
    },
    getBanner() {
      this.$http.getOnlyContent({
        itemType: '2',
        platform: 'mb',
        language: this.lang === 'zh' ? 'china' : 'english'
      }).then(res => {
        this.banner = res.imageMaps['20'][0];
      });
    }
  },
  watch: {
    lang: {
      immediate: true,
      handler(v) {
        this.getDataByLang(v);
      }
    }
  },
  created() {
    this.getBanner();
  }
}
</script>

<style lang="less">
@import "../../common/theme";
.mobile-home {
  .forum {
    .intro {
      >p {
        text-indent: 2em;
        margin-bottom: 10px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .pur-con {
      background-image: url("../../assets/bg-2.jpg");
      background-size: cover;
      background-position: 50% 50%;
      padding-top: calc(@mobileFont * .55);
      padding-bottom: calc(@mobileFont * .55);
      .item {
        font-size: 0;
        & ~ .item {
          margin-top: 20px;
        }
        >* {
          display: inline-block;
          vertical-align: top;
        }
        img {
          width: calc(@mobileFont * 1);
          margin-right: 20px;
        }
        p, span {
          font-size: calc(@mobileFont * .28);
        }
        .txt-box {
          width: calc(100% - @mobileFont - 20px);
          span {
            display: inline-block;
            font-size: calc(@mobileFont * .30);
            margin-bottom: 5px;
            color: #037698;
            font-weight: bolder;
          }
          p {
            text-indent: 2em;
          }
        }
      }
    }

    .mission {
      .con {
        img {
          width: 120px;
          height: 80px;
        }
        .box {
          font-size: 0;
          & ~ .box {
            margin-top: 30px;
            padding-bottom: 20px;
            border-bottom: 1px solid #d2d2d2;
          }
          >* {
            display: inline-block;
            vertical-align: middle;
          }
          .txt-box {
            width: calc(100% - 140px);
            p {
              &:nth-child(1) {
                font-size: calc(@mobileFont * .30);
                color: #037698;
                font-weight: bolder;
              }
              &:nth-child(2) {
                font-size: calc(@mobileFont * .28);
              }
            }
          }
        }
        .box-1 img {
          margin-right: 20px;
        }
        .box-2 img {
          margin-left: 20px;
        }
      }
    }

    .work {
      .item {
        font-size: 0;
        padding: 15px 0;
        & ~ .item {
          border-top: 1px solid #d2d2d2;
        }
        >* {
          display: inline-block;
          vertical-align: top;
        }
        img {
          width: calc(@mobileFont * .8);
          margin-right: 20px;
        }
        p, span {
          font-size: calc(@mobileFont * .28);
        }
        .txt-box {
          width: calc(100% - @mobileFont - 20px);
          p:nth-child(1) {
            font-size: calc(@mobileFont * .30);
            margin-bottom: 5px;
            color: #037698;
            font-weight: bolder;
          }
          p:nth-child(2) {
            text-indent: 2em;
          }
        }
      }
    }

    .research-area {
      .ra-item {
        padding-top: 30px;
        background: #eee;
        .tit-img {
          display: flex;
          align-items: center;
          margin-bottom: 30px;
          .img-box {
            width: 60%;
            height: 115px;
            img {
              display: block;
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          .txt-box {
            width: 40%;
            text-align: center;
            background: #fff;
            height: 115px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            span {
              &:nth-child(1) {
                font-size: calc(@mobileFont * .3);
                color: #037698;
                font-weight: bold;
                padding-bottom: 5px;
              }
              &:nth-child(2) {
                font-size: calc(@mobileFont * .2);
                color: #037698;
              }
            }
          }
        }
        .intro {
          padding-bottom: 30px;
          border-bottom: 1px solid #d2d2d2;
          text-indent: 2rem;
        }
      }
      .ra-menu-list {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 30px;
        padding-bottom: 50px;
        background: #eee;
        .ra-menu-item {
          width: calc((100% - 30px) / 5);
          text-align: center;
          img {
            display: block;
            width: calc(@mobileFont * .6);
            margin: 0 auto calc(@mobileFont * .3);
            background: #eee;
          }
          p {
            font-size: 14px;
          }
        }
      }
    }

    .scope-work {
      .work-item {
        display: flex;
        padding-top: 30px;
        padding-bottom: 30px;
        border-bottom: 1px solid #D2D2D2;
        &.work-item-0 {
          padding-top: 10px;
        }
        .img {
          width: 45%;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .other-msg {
          padding-left: calc(@mobileFont * .3);
          width: 55%;
          position: relative;
          p {
            font-size: calc(@mobileFont * .28);
            font-weight: bold;
            color: #037698;
          }
          .line {
            width: calc(@mobileFont * .66);
            height: calc(@mobileFont * .07);
            background: #037698;
            border-radius: 4px;
            margin: 8px 0;
          }
          .desc-box {
            font-size: calc(@mobileFont * .24);
          }
          .float-num {
            position: absolute;
            right: 0;
            top: 5px;
            background: #037698;
            color: #fff;
            padding: 5px;
            border-bottom-left-radius: 4px;
            transform: scale(0.85, 1.1);
            font-weight: bold;
          }
        }
      }
    }

    .major-event {
      >img {
        display: block;
        width: 100%;
      }
      //.event-wrap {
      //  display: flex;
      //  padding-left: calc(@mobileFont * .17 / 2);
      //  .img {
      //    padding-bottom: calc(@mobileFont * .66);
      //    &:before {
      //      content: '';
      //      display: block;
      //      width: calc(@mobileFont * .17);
      //      height: calc(@mobileFont * .17);
      //      border-radius: 50%;
      //      background: #037698;
      //      position: absolute;
      //      left: calc(-1 * ((@mobileFont * .17) / 2) - 0.5px);
      //      top: calc((@mobileFont * .42) - (@mobileFont * .17 / 2));
      //    }
      //    img {
      //      width: calc(@mobileFont * 1.46);
      //    }
      //  }
      //  .line-wrap {
      //    position: relative;
      //    padding-top: calc(@mobileFont * .42);
      //    .left-dash-line {
      //      width: 1px;
      //      height: calc(100% - 30px - (@mobileFont * .42));
      //      border-left: 1px dashed #D2D2D2;
      //    }
      //  }
      //}
      //.event-item {
      //  padding-bottom: calc(@mobileFont * .78);
      //  &:before {
      //    content: '';
      //    display: block;
      //    width: calc(@mobileFont * .09);
      //    height: calc(@mobileFont * .09);
      //    border-radius: 50%;
      //    background: #7b7b7b;
      //    position: absolute;
      //    left: calc(-1 * ((@mobileFont * .09) / 2) - 0.5px);
      //    top: calc((@mobileFont * .35) - 10px - (@mobileFont * .09 / 2));
      //  }
      //  .time-box {
      //    color: #037698;
      //    margin-bottom: 10px;
      //    font-size: calc(@mobileFont * .3);
      //  }
      //  .desc-box {
      //    font-size: 13px;
      //    line-height: 22px;
      //  }
      //}
      //.has-circle {
      //  padding-left: calc(@mobileFont * .27);
      //  position: relative;
      //}
    }
  }
}
</style>
